import { useTheme } from '@mui/material';

export const chartColors = {
  female: '#f6ba00',
  male: '#4da72d',
  text: '#fff',
  blue: '#0f9ed4',
  darkBlue: '#0a75a0',
};

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    kpiLayout: {
      display: 'grid',
      gridTemplateAreas: `
        "genderLabel ageLabel compensationLabel femalesAllLabel femalesMalesLabel"
        "femaleCount femaleAge femaleCompensation femalesAll femalesMales"
        "maleCount maleAge maleCompensation femalesAll femalesMales"
      `,
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: theme.spacing(1),
    },
    femaleKpi: {
      backgroundColor: chartColors.female,
      color: chartColors.text,
    },
    maleKpi: {
      backgroundColor: chartColors.male,
      color: chartColors.text,
    },
    blueKpi: {
      backgroundColor: chartColors.blue,
      color: chartColors.text,
    },
    darkBlueKpi: {
      backgroundColor: chartColors.darkBlue,
      color: chartColors.text,
    },
    chartHeading: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 0),
      alignItems: 'center',
    },
    chartHeadingWithSelector: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    chartsLayout: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: theme.spacing(1),
    },
    chartContainer: {
      height: '350px',
      width: '100%',
      maxWidth: '100%',
      position: 'relative',
    },
  };
};
